// extracted by mini-css-extract-plugin
export default {"statusBar_text":"StatusBarText_statusBar_text__g21VD"};